import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { createIDBPersister } from './lib/Persister.js';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from 'react-router-dom';
import { router } from './public/router.jsx';
import { setQueryClient } from './lib/Queries';
import '~/lib/Polyfills.js';

import * as Sentry from '@sentry/react';
import { setPublicQueryClient } from '~/public/lib/PublicQueries';

if (!import.meta.env.DEV) {
    // Sentry.init({
    //     dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    // });
    Sentry.init({
        dsn: 'https://2e07a7458023851bc8954225ea8f1d02@o1399723.ingest.us.sentry.io/4507817103851520',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 0.1, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/app\.breely\.com\/api/,
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            //refetchInterval: 60 * 60 * 1000, // 1 hour
            gcTime: 1000 * 60 * 60 * 24 * 5, // 5 Days
        },
    },
});
setQueryClient(queryClient);
setPublicQueryClient(queryClient);

const asyncStoragePersister = createAsyncStoragePersister({
    storage: createIDBPersister(),
});

const App = ({}) => {
    return (
        <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{ persister: asyncStoragePersister }}
        >
            <RouterProvider router={router}>
                <div>...</div>
            </RouterProvider>
        </PersistQueryClientProvider>
    );
};

if (document.getElementById('app')) {
    const root = createRoot(document.getElementById('app'));
    root.render(<App />);
}
